<template>
  <div class="log-tabs">
    <ErrorModal />
    <DxTabPanel
      class="logs-tabs-container"
      styling-mode="secondary"
      tabs-position="top"
      icon-position="start"
      :defer-rendering="true"
      @selection-changed="handleItemClick"
      width="100%"
    >
      <template v-for="tab in tabs" :key="tab.id">
        <DxItem :title="tab.text" icon-position="start">
          <component
            :is="loadComponent(tab.component, tab.id)"
          />
        </DxItem>
      </template>
    </DxTabPanel>
  </div>
</template>
<script setup>
import { ref, defineAsyncComponent, markRaw } from "vue";
import { DxTabPanel, DxItem } from "devextreme-vue/tab-panel";

import ErrorModal from "../../components/ai-tabs-components/ErrorModal.vue";
const tabs = ref([
  { id: 0, text: "Analytics", component: "AnalyticsLogs" },
  { id: 1, text: "Moderation", component: "ModerationLogs" },
  { id: 2, text: "Rate limit", component: "RateLimitLogs" }
]);
const componentCache = new Map();

const loadComponent = componentName => {
  if (!componentCache.has(componentName)) {
    componentCache.set(
      componentName,
      markRaw(
        defineAsyncComponent(() =>
          import(`./logs-tabs/${componentName}Tab.vue`)
        )
      )
    );
  }
  return componentCache.get(componentName);
};

const handleItemClick = e => {
  const selectedIndex = e.component.option("selectedIndex");

  if (
    typeof selectedIndex !== "number" ||
    selectedIndex < 0 ||
    selectedIndex >= tabs.value.length
  ) {
    return;
  }

  const selectedTab = tabs.value[selectedIndex];
  
  if (!selectedTab) {
    return;
  }
};
</script>

<style scoped></style>
